<script lang="ts">
type ItemSpace = '3' | '5';

type BlockListItem =
    | string
    | {
          title: string;
          description: string;
      };

export type BlockListProps = {
    title?: string;
    description?: string;
    items?: BlockListItem[];
    space?: ItemSpace;
    icon?: string;
};
</script>
<script setup lang="ts">
// PROPS
const props = withDefaults(defineProps<BlockListProps>(), {
    space: () => '3',
    items: () => [],
});

// DATA
const itemSpace = computed(() => (props.space === '3' ? 'space-y-3' : 'space-y-5'));
</script>

<template>
    <div class="flex flex-col gap-y-6">
        <h3 v-if="$slots.title || !!title" class="text-primary-800 text-3xl font-semibold">
            <slot name="title">{{ title }}</slot>
        </h3>
        <div v-if="$slots.description || !!description" class="text-base">
            <slot name="description">{{ description }}</slot>
        </div>
        <ul v-if="$slots.list || !!items" class="list-none text-base" :class="itemSpace">
            <li v-for="(item, index) in items" :key="index" class="flex items-center gap-4">
                <UIcon v-if="icon" class="size-4 self-start" :name="icon" />
                <span v-else class="text-primary self-start font-bold" :class="{ 'w-[1.875rem] text-xl': typeof item !== 'string' }">
                    {{ formatBlockIndex(index + 1) }}
                </span>

                <template v-if="typeof item === 'string'">
                    <span class="font-medium">{{ item }}</span>
                </template>
                <template v-else>
                    <div class="flex flex-col gap-2">
                        <h4 class="text-xl font-semibold">{{ item.title }}</h4>
                        <p>{{ item.description }}</p>
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>
